class Audio {
  constructor() {
    this.instance = null;

    window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
    this.context = new window.AudioContext();;
    this.source = null;
    this.audioBuffer = null;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new Audio();
    }
    return this.instance;
  }

  stopSound() {
      if (this.source) {
          this.source.stop(0); //立即停止
      }
  }

  playSound() {
    this.source = this.context.createBufferSource();
    this.source.buffer = this.audioBuffer;
    this.source.loop = false; //循环播放
    this.source.connect(this.context.destination);
    this.source.start(0); //立即播放
  }

  initSound(arrayBuffer) {
    let self = this;
      this.context.decodeAudioData(arrayBuffer, function(buffer) { //解码成功时的回调函数
          self.audioBuffer = buffer;
          self.playSound();
      }, function(e) { //解码出错时的回调函数
          console.log('Error decoding file', e);
      });
  }

  loadAudioFile(url) {
      let self = this;
      let xhr = new XMLHttpRequest(); //通过XHR下载音频文件
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() { //下载完成
          self.initSound(this.response);
      };
      xhr.send();
  }

  tingNotice() {
    let time = (new Date()).getTime();
    this.lastaudiotime = this.lastaudiotime || 0;
    if (time - this.lastaudiotime < 1000) {
      return false;
    }
    console.log('play...');
    if (this.audioBuffer != null) {
        this.playSound();
    } else {
        this.loadAudioFile(require('../static/audio/ting.ogg'));
    }
    this.lastaudiotime = time;
  }
}

export default Audio.getInstance();
